import { useGetGroupPostsInfinite } from '@repo/api/group/useGetGroupPostsInfinite';

import PostList from '@/components/features/post/PostList';

interface GroupPostsProps {
  groupId: number;
}

export default function GroupPosts(groupPostsProps: GroupPostsProps) {
  const { groupId } = groupPostsProps;

  const query = useGetGroupPostsInfinite(groupId);

  return <PostList query={query} options={{ groupId: groupId }} />;
}
